// Strings for the desktop layout variants.
//
// OWNED BY ONE TRACK. This file exists so parallel work on separate screens
// never lands in the same catalogue (the 2026-08 build-out track plan; retired
// 2026-10-20, in git at 17b3da5e:docs/planning/ui-buildout-tracks.md).
// Add only keys under: flow.desktop
//
// SPANISH IS NOT INVENTED HERE. Product's rule, inherited from core.ts: copy a
// client reads before paying someone must not be machine-translated. Leave `es`
// empty unless a string is unambiguous; the validator counts the gap so it stays
// visible rather than silently falling back forever.

export const en = {} as const;
